const rules = new Intl.PluralRules('ru')

/** Форма слова для числа: plural(3, ['задача', 'задачи', 'задач']) → 'задачи'. */
export function plural(n: number, forms: readonly [one: string, few: string, many: string]): string {
  switch (rules.select(n)) {
    case 'one':
      return forms[0]
    case 'few':
      return forms[1]
    case 'many':
      return forms[2]
    default:
      // дробные числа
      return forms[1]
  }
}

/** Число со словом: pl(5, [...]) → '5 задач'. */
export function pl(n: number, forms: readonly [string, string, string]): string {
  return `${n} ${plural(n, forms)}`
}

export const TASK_FORMS = ['задача', 'задачи', 'задач'] as const
export const DAY_FORMS = ['день', 'дня', 'дней'] as const
export const HOUR_FORMS = ['час', 'часа', 'часов'] as const
export const WORKDAY_FORMS = ['рабочий день', 'рабочих дня', 'рабочих дней'] as const
export const PERSON_FORMS = ['человек', 'человека', 'человек'] as const
